import { Effect } from 'effect'
import type { FileReadError } from './archive-errors'
import type { FileEntry } from './file-entry'
import { sha256 } from './web-crypto'

export function hashFile(fileEntry: FileEntry): Effect.Effect<string, FileReadError> {
  return fileEntry.readBytes.pipe(Effect.flatMap(sha256))
}
